import 'moment/locale/th'
import React, { useState, useEffect, useRef, Fragment } from 'react'
import { getTheme } from '../../helpers/helpers'
import callApi from '../../helpers/callapi'
import moment from 'moment'
import { orderBy } from 'lodash'
import styled from 'styled-components'
import GridBook from './Grid'
import ListBook from './List'
import { Card, Form, Row, Col, Button, Table } from 'react-bootstrap'
import { getRounds } from '../../services/config-services'

moment.locale('th')
const Scaning = () => {
  const [loading, setLoading] = useState(false)
  const [roundDate, setRoundDate] = useState()
  const [currentBarcode, setCurrentBarcode] = useState('')
  const [duplicate, setDuplicate] = useState({})
  const [bookTable, setBookTable] = useState([])
  const [rounds, setRounds] = useState([])
  const [perRow, setPerRow] = useState(10)
  const [barcode, setBarcode] = useState('')
  const [view, setView] = useState(true)
  const roundNoRef = useRef()

  const fetchAllRounds = async () => {
    const data = await getRounds()
    setRoundDate(data[0].value)
    setRounds(data.map((r) => ({ roundDate: r.value })))
    setLoading(false)
  }
  function beep(type = 'success') {
    const sound = {
      success: '/beep-success.mp3',
      fail: '/beep-fail.mp3',
      duplicate: '/dup.mp3',
    }
    const beepsound = new Audio(sound[type])
    beepsound.play()
  }
  function barcodeToBook(barc) {
    let tempSeriesNo = barc.slice(4, 6)
    return {
      year: barc.slice(0, 2),
      roundNo: barc.slice(2, 4),
      seriesNo: { [tempSeriesNo]: barc },
      volume: barc.slice(-6, -2),
      ending: barc.slice(-2),
      rank: Math.ceil(parseInt(tempSeriesNo) / 5),
    }
  }
  function findDuplicateIndex(books, target) {
    let id = -1
    books.forEach((book, i) => {
      let found = target.roundNo === book.roundNo && target.volume === book.volume && target.rank === book.rank
      found && (id = i)
    })
    return id
  }
  const addBook = async () => {
    const tempBookTable = addBookToTable([...bookTable], barcode)
    setBookTable(tempBookTable)
    try {
      const body = {
        timestamp: +new Date(),
        roundDate: roundDate,
        id: barcode,
      }
      callApi({
        url: '/books',
        method: 'POST',
        body,
      })
      window.scrollTo(0, document.body.scrollHeight)
    } catch (error) {
      beep('fail')
    }
  }
  const fetchBooks = async () => {
    if (!roundDate) return
    try {
      setLoading(true)
      const barcodes = await callApi({
        url: '/books',
        query: { roundDate: roundDate },
      })
      setBookTable(makeTableBook(barcodes))
      setLoading(false)
    } catch (error) {
      setBookTable([])
      setLoading(false)
    }
  }
  const makeTableBook = (barcs) => {
    const tempBookTable = barcs.reduce((result, barc) => {
      return addBookToTable(result, barc.id, false)
    }, [])
    return tempBookTable
  }
  const addBookToTable = (result, barc, sound = true) => {
    let book = barcodeToBook(barc)
    let dul = findDuplicateIndex(result, book)
    if (dul >= 0) {
      result[dul].seriesNo = { ...result[dul].seriesNo, ...book.seriesNo }
      setDuplicate({
        row: Math.ceil((dul + 1) / perRow),
        collumn: (dul + 1) % perRow,
        volume: book.volume,
      })
      sound && beep('duplicate')
      return result
    } else {
      sound && beep('success')
      return [...result, book]
    }
  }
  const onEnter = (e) => {
    if (e.key === 'Enter' && e.target.value.length === 16) {
      addBook()
      setBarcode('')
    } else if (e.key === 'Enter') {
      beep('fail')
      setBarcode('')
    }
  }
  const isHilight = (book) => {
    let barcs = Object.values(book.seriesNo)
    return barcs.some((barc) => barc === currentBarcode)
  }
  const setAllBarcode = (barc) => {
    setCurrentBarcode(barc)
    setBarcode(barc)
  }
  useEffect(async () => {
    setLoading(true)
    fetchAllRounds()
  }, []) //get round list
  useEffect(async () => {
    fetchBooks()
  }, [roundDate]) //get lottery in the round
  useEffect(async () => {
    try {
      const result = {}
      bookTable.forEach((book) => {
        const count = Object.keys(book.seriesNo).length
        if (count === 1) {
          result[book.roundNo + '-' + Object.keys(book.seriesNo)[0]] =
            result[book.roundNo + '-' + Object.keys(book.seriesNo)[0]] || 0
          result[book.roundNo + '-' + Object.keys(book.seriesNo)[0]]++
        } else {
          result[count] = result[count] || 0
          result[count]++
        }
      })
    } catch (err) {
      console.log(err)
    }
  }, [bookTable])

  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Title>Scaning</Card.Title>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col sm={12} md={4}>
              <Form.Group>
                <Form.Label>งวดวันที่</Form.Label>
                <Form.Control
                  as="select"
                  defaultValue={roundDate}
                  onChange={async (value) => {
                    setRoundDate(value.target.value)
                  }}
                >
                  {rounds.map((round, i) => {
                    return (
                      <option key={i} value={round.roundDate}>
                        {round.roundDate}
                      </option>
                    )
                  })}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col sm={12} md={4}>
              <Form.Group>
                <Form.Label>แสดงแถวละ</Form.Label>
                <Form.Control
                  type="number"
                  defaultValue={perRow}
                  onKeyDown={(e) => e.preventDefault()}
                  onChange={(e) => setPerRow(e.target.value)}
                  ref={roundNoRef}
                />
              </Form.Group>
            </Col>
            <Col sm={12} md={4}>
              <Form.Group>
                <Form.Label>บาร์โค้ด</Form.Label>
                <Form.Control
                  type="text"
                  defaultValue={barcode}
                  maxLength="16"
                  onChange={(e) => {
                    let val = e.target.value
                    val.match(/^[0-9]*$/) && setAllBarcode(val)
                  }}
                  onKeyDown={onEnter}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="d-flex justify-content-center mb-3">
            <Button variant="primary light" onClick={() => setView(!view)}>
              มุมมอง
            </Button>
          </Row>
          <Row>
            {view ? (
              <GridBook
                bookTable={bookTable}
                perRow={perRow}
                barcode={barcode}
                isHilight={isHilight}
                setBarcode={setAllBarcode}
              />
            ) : (
              <ListBook
                bookTable={bookTable}
                perRow={perRow}
                barcode={barcode}
                setBookTable={setBookTable}
                isHilight={isHilight}
                setBarcode={setAllBarcode}
                setLoading={setLoading}
                roundDate={roundDate}
              />
            )}
          </Row>
          {/* {!view && (
            <table className="table">
              <thead>
                <tr>
                  <td>แถวที่</td>
                  <td>งวดที่</td>
                  <td>ชุดที่</td>
                  <td>เล่มที่</td>
                  <td>จำนวนคู่</td>
                </tr>
              </thead>
              <tbody>
                {bookTable.map((book, i) => {
                  return (
                    <TR
                      key={i}
                      width={100 / perRow}
                      hilight={isHilight(book)}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setBarcode(
                          Object.values(book.seriesNo) &&
                            Object.values(book.seriesNo)[0]
                        );
                      }}
                    >
                      <td>{Math.ceil((i + 1) / perRow)}</td>
                      <td>{book.roundNo}</td>
                      <td>{Object.keys(book.seriesNo).join(",")}</td>
                      <td>{book.volume}</td>
                      <td>{book.seriesNo.length || 0}</td>
                    </TR>
                  );
                })}
              </tbody>
            </table>
          )} */}
        </Card.Body>
      </Card>
    </Fragment>
  )
}
const TR = styled.tr`
  background-color: ${(props) => props.hilight && 'yellow'};
  flex: ${(props) => props.width}%;
`
export default Scaning
